import { render, staticRenderFns } from "./users-green-card.vue?vue&type=template&id=1edad705&scoped=true"
import script from "./users-green-card.vue?vue&type=script&lang=js"
export * from "./users-green-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edad705",
  null
  
)

export default component.exports